const CloseOutlined = ({ size = 16 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    fill='none'
    viewBox='0 0 16 16'
  >
    <path
      fill='#25314C'
      d='M12.353 11.647a.5.5 0 0 1-.707.707L8 8.707l-3.647 3.647a.5.5 0 0 1-.706 0 .5.5 0 0 1 0-.707L7.293 8 3.647 4.353a.5.5 0 0 1 .707-.707L8 7.293l3.646-3.647a.5.5 0 1 1 .707.707L8.709 8z'
    />
  </svg>
);

export default CloseOutlined;
